import moment from 'moment';
import Vue from 'vue';
/**
 * 声明filter
 */
const filters = {
  dateFormater(t) {
    if (t && t.length > 1) {
      return moment(t).format('YYYY-MM-DD HH:mm')
    } else {
      return ''
    }
  },
  startdateFormater(t) {
    if (t && t.length > 1) {
      return moment(t).format('YYYY-MM-DD')
    } else {
      return ''
    }
  },
  dateFormatDefault(t) {
    return moment(t).format('YYYY-MM-DD HH:mm:ss')
  },
  codeFormater(code) {
    return code.substr(0, 4) + '****' + code.substr(code.length - 4)
  },
  timeFormater(second) {
    if (typeof + second !== 'number') {
      return '-'
    }
    if (second < 60) {
      return second + '秒'
    }
    if (second >= 60 && second < 60 * 60) {
      var m = parseInt(second / 60)
      var s = second % 60
      return m + '分' + (s ? (s + '秒') : '钟')
    }
    if (second > 60 * 60 && second / 60 % 60 !== 0) {
      return (second / 60 / 60).toString().split('.')[0] + '.' + (second / 60 / 60 % 1).toFixed(1).split('.')[1] + '小时'
    }
    if (second / 60 % 60 === 0) {
      var m = second / 60 / 60
      return m + '小时'
    }
  },
  // 计算重复时间,能源的定时表页面
  getRepeat(row) {
    const repeat = row.repeat;
    switch (repeat) {
      case 0:
        return "执行一次";
        break;
      case 1:
        return "每天";
        break;
      case 2:
        return "工作日";
        break;
      case 3:
        return "周末";
        break;
      case 4:
        const dayOfWeeks = JSON.parse(JSON.stringify(row)).dayOfWeek.split(
          ","
        );
        const dayOfWeekList = [];
        dayOfWeeks.forEach(item => {
          switch (item) {
            case "1":
              const Monday = "周一";
              return dayOfWeekList.push(Monday);
              break;
            case "2":
              const Tuesday = "周二";
              return dayOfWeekList.push(Tuesday);
              break;
            case "3":
              const Wednesday = "周三";
              return dayOfWeekList.push(Wednesday);
              break;
            case "4":
              const Thursday = "周四";
              return dayOfWeekList.push(Thursday);
              break;
            case "5":
              const Friday = "周五";
              return dayOfWeekList.push(Friday);
              break;
            case "6":
              const Saturday = "周六";
              return dayOfWeekList.push(Saturday);
              break;
            case "0":
              const Sunday = "周末";
              return dayOfWeekList.push(Sunday);
              break;
          }
        });
        return dayOfWeekList.join(",");
        break;
      case 5:
        const day = JSON.parse(JSON.stringify(row)).day.split(
          ","
        );
        const dayList = [];
        day.forEach(item => {
          switch (item) {
            case "1":
              const a = "1号";
              return dayList.push(a);
              break;
            case "2":
              const b = "2号";
              return dayList.push(b);
              break;
            case "3":
              const c = "3号";
              return dayList.push(c);
              break;
            case "4":
              const d = "4号";
              return dayList.push(d);
              break;
            case "5":
              const e = "5号";
              return dayList.push(e);
              break;
            case "6":
              const f = "6号";
              return dayList.push(f);
              break;
            case "7":
              const g = "7号";
              return dayList.push(g);
              break;
            case "8":
              const h = "8号";
              return dayList.push(h);
              break;
            case "9":
              const i = "9号";
              return dayList.push(i);
              break;
            case "10":
              const j = "10号";
              return dayList.push(j);
              break;
            case "11":
              const k = "11号";
              return dayList.push(k);
              break;
            case "12":
              const l = "12号";
              return dayList.push(l);
              break;
            case "13":
              const m = "13号";
              return dayList.push(m);
              break;
            case "14":
              const n = "14号";
              return dayList.push(n);
              break;
            case "15":
              const o = "15号";
              return dayList.push(o);
              break;
            case "16":
              const p = "16号";
              return dayList.push(p);
              break;
            case "17":
              const q = "17号";
              return dayList.push(q);
              break;
            case "18":
              const r = "18号";
              return dayList.push(r);
              break;
            case "19":
              const ss = "19号";
              return dayList.push(ss);
              break;
            case "20":
              const t = "20号";
              return dayList.push(t);
              break;
            case "21":
              const u = "21号";
              return dayList.push(u);
              break;
            case "22":
              const v = "22号";
              return dayList.push(v);
              break;
            case "23":
              const w = "23号";
              return dayList.push(w);
              break;
            case "24":
              const s = "24号";
              return dayList.push(s);
              break;
            case "25":
              const y = "25号";
              return dayList.push(y);
              break;
            case "26":
              const z = "26号";
              return dayList.push(z);
              break;
            case "27":
              const aa = "27号";
              return dayList.push(aa);
              break;
            case "28":
              const bb = "28号";
              return dayList.push(bb);
              break;
            case "29":
              const cc = "29号";
              return dayList.push(cc);
              break;
            case "30":
              const dd = "30号";
              return dayList.push(dd);
              break;
            case "31":
              const ee = "月底";
              return dayList.push(ee);
              break;
          }
        });
        return dayList.join(",");
      default:
    }
  },
}
/**
 * 全局注册filter
 */
Object.keys(filters).forEach(filterkey => {
  Vue.filter(filterkey, filters[filterkey])
})



// WEBPACK FOOTER //
// ./src/util/filters.js